import React from "react";

export const CloseButton: React.FC<{
  width?: string;
  height?: string;
  onClick: () => void;
}> = ({ width = "24", height = "24", onClick }) => {
  return (
    <button type="button" onClick={onClick} aria-label="Close the notification">
      <svg
        cursor="pointer"
        width={width}
        height={height}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.9249 7.15869C7.71332 6.9471 7.37027 6.9471 7.15869 7.15869C6.9471 7.37027 6.9471 7.71332 7.15869 7.9249L13.2338 14L7.15869 20.0751C6.9471 20.2867 6.9471 20.6297 7.15869 20.8413C7.37027 21.0529 7.71332 21.0529 7.9249 20.8413L14 14.7662L20.0751 20.8413C20.2867 21.0529 20.6297 21.0529 20.8413 20.8413C21.0529 20.6297 21.0529 20.2867 20.8413 20.0751L14.7662 14L20.8413 7.9249C21.0529 7.71332 21.0529 7.37027 20.8413 7.15869C20.6297 6.9471 20.2867 6.9471 20.0751 7.15869L14 13.2338L7.9249 7.15869Z"
          fill="#1D1D1B"
        />
      </svg>
    </button>
  );
};
